export default __webpack_public_path__ + "static/media/anti-corruption.d37b220f.svg";